import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles.css";
import { AuthProvider, useAuth } from "./auth";
import { Shell } from "./Shell";
import { Login } from "./Login";
import { Landing } from "./Landing";
import { Portfolio } from "./Portfolio";
import { EstateDetail } from "./EstateDetail";
import { Users } from "./Users";

/** True when running on app.lighthouseapp.net (or localhost dev).
 *  Anywhere else (www, apex) we serve the marketing landing. */
const isAppHost = () => {
  if (typeof window === "undefined") return true;
  const h = window.location.hostname;
  return h.startsWith("app.") || h.startsWith("localhost") || h.startsWith("127.");
};

function App() {
  const { me, idToken, loading } = useAuth();

  if (loading) {
    return (
      <Shell>
        <div className="empty"><span className="spinner" /> Loading…</div>
      </Shell>
    );
  }

  // Marketing landing for anyone hitting the apex / www. Anonymous
  // visitors get the pitch + a CTA; once they sign in we boot them
  // into the dashboard at app.lighthouseapp.net.
  if (!isAppHost()) {
    return (
      <Shell>
        <Landing />
      </Shell>
    );
  }

  if (!idToken) {
    return (
      <Shell>
        <Login />
      </Shell>
    );
  }

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/estates/:id" element={<EstateDetail />} />
        <Route path="/users" element={me?.is_superuser ? <Users /> : <Portfolio />} />
        <Route path="/auth/callback" element={<div className="empty"><span className="spinner" /> Completing sign-in…</div>} />
      </Routes>
    </Shell>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
